import qs from 'qs'
import { parseQuery } from './queryHelper'

export const goToPage = (searchParams, history, pageNum, pathname) => {
  const realSearch = parseQuery(searchParams)
  const { limit } = realSearch
  const newOffset = Number(limit) * (pageNum - 1)

  const newSearch = Object.assign({}, realSearch, { offset: newOffset })
  history.push({
    pathname,
    search: qs.stringify(newSearch),
  })
}

export const nextPage = (searchParams, history, count, pathname) => {
  const realSearch = parseQuery(searchParams)
  const { offset, limit } = realSearch
  if (count === limit) {
    const newOffset = parseInt(offset, 10) + Number(limit)
    const newSearch = Object.assign({}, realSearch, { offset: newOffset })
    history.push({
      pathname,
      search: qs.stringify(newSearch),
    })
  }
}

export const previousPage = (searchParams, history, pathname) => {
  const realSearch = parseQuery(searchParams)
  const { offset, limit } = realSearch
  if (offset >= limit) {
    const newOffset = offset >= limit ? offset - limit : 0
    const newSearch = Object.assign({}, realSearch, { offset: newOffset })
    history.push({
      pathname,
      search: qs.stringify(newSearch),
    })
  }
}
